import styled from 'styled-components'

import A from '../A'
import { mq, sizes } from '../../theme'

export const Container = styled.footer`
  .noOverflow & {
    display: none;
  }
  position: relative;
  z-index: ${({ theme }) => theme.zIndexes.header - 1};
  background-color: ${({ theme }) => theme.colors.pureWhite ?? 'white'};
  border-radius: 3rem 3rem 0 0;
  margin-top: -1rem;
  box-shadow: 0 -8px 20px 0 rgba(0, 0, 0, 0.09);
  @media ${mq(sizes.desktop)} {
    box-shadow: 0 -8px 20px 0 rgba(0, 0, 0, 0.09);
    margin-top: -6rem;
    border-radius: 6rem 6rem 0 0;
  }
  @media print {
    display: none;
  }
`
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${({ theme }) =>
    `calc(${theme.sizes.mangerBougerDesktop / 10}rem)` ?? 'none'};
  margin-left: auto;
  margin-right: auto;
  margin-top: -3rem;
  @media ${mq(sizes.desktop)} {
    margin-top: 6rem;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    padding-left: 0;
    padding-right: 0;
    padding-top: 6rem;
    & > * {
      position: relative;
    }
  }
`
export const Menu = styled.div`
  display: none;
  @media ${mq(sizes.desktop)} {
    display: flex;
    justify-content: space-between;
    width: 100%;
    &::after {
      content: '';
      inset: 0.5rem auto 1rem 0;
      background: ${({ theme }) => theme.colors.greyDD ?? 'lightgrey'};
      width: 2px;
      order: 1;
      margin-right: 3rem;
    }
  }
`
export const MenuItem = styled.div`
  display: flex;
  flex-direction: column;
  order: 0;
  max-width: calc(100% / 4);
  padding-right: 2rem;
  &:last-child {
    order: 2;
  }
`
export const MenuItemLink = styled(A)`
  text-transform: uppercase;
  ${({ theme }) => theme.textStyles.text_medium_12}
  font-weight: 700;
  color: ${({ theme }) => theme.colors.footer};
  text-decoration: none;
`

export const MenuItemEntries = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1.8rem;
`
export const MenuSubItem = styled(A)`
  ${({ theme }) => theme.textStyles.text_medium_14}
  color: ${({ theme }) => theme.colors.footer};
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 2px;
  text-underline-position: under;
  text-decoration-color: transparent;
  transition: text-decoration-color 0.3s;
  &:not(:last-child) {
    padding-bottom: 1rem;
  }
  &:hover {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-thickness: 2px;
    text-underline-position: under;
    text-decoration-color: ${({ theme }) => theme.colors.greenApple};
  }
`

export const Bottom = styled.div`
  width: 100%;
  @media ${mq(sizes.desktop)} {
    display: grid;
    grid-template-columns: 28.8rem 16rem 1fr;
    grid-template-rows: 1fr;
    column-gap: 3.8rem;
    position: relative;
    align-items: center;
    margin-top: 2rem;
    padding: 2rem 0;
    &::before {
      content: '';
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: ${({ theme }) => theme.colors.greyDD ?? 'lightgrey'};
      position: absolute;
    }
  }
`
//
export const Logos = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  position: relative;
  & > * {
    position: relative;
    width: 50%;
    padding: 2rem;
    @media ${mq(sizes.desktop)} {
      padding: 0;
      justify-content: flex-start;
      &:first-child {
        width: 9.8rem;
      }
      &:first-child + & {
        width: 11rem;
      }
    }
  }
  width: 100%;
  @media ${mq(0, sizes.desktop - 1)} {
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.greyDD ?? 'lightgrey'};
  }
  @media ${mq(sizes.desktop)} {
    align-items: center;
    justify-content: space-between;
  }
`
export const Logo = styled(A)<{ width?: any }>`
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Main = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  @media ${mq(sizes.tablet)} {
    min-height: 8.8rem;
  }
  @media ${mq(sizes.desktop)} {
    height: 11.5rem;
    justify-content: center;
    padding: 0;
    & > * {
      margin-left: 0;
    }
  }
`
export const MainLogo = styled.div`
  max-width: 16.2rem;
  ${Logo} > div {
    height: 3.6rem;
  }
  @media ${mq(0, sizes.desktop - 1)} {
  }
`
export const Socials = styled.ul`
  display: flex;
  justify-content: row nowrap;
  list-style: none outside;
  @media ${mq(sizes.desktop)} {
    position: absolute;
    right: 8rem;
  }
  &:not(:first-child) {
    padding-top: 2rem;
    @media ${mq(sizes.desktop)} {
      padding-top: 0;
    }
  }
  & li:not(:first-child) {
    margin-left: 2rem;
  }
`
export const Legals = styled.div`
  background: ${({ theme }) => theme.colors.grey44};
`

export const LegalsUl = styled.ul`
  background: ${({ theme }) => theme.colors.grey44};
  padding: 4.5rem 4.25rem;
  display: flex;
  flex-direction: column;
  list-style: none;
  max-width: ${({ theme }) =>
    `calc(${theme.sizes.boxContent / 10}rem + 16rem)` ?? 'none'};
  margin-left: auto;
  margin-right: auto;
  @media ${mq(sizes.mobile)} {
    padding: 4.5rem 7.25rem;
  }
  @media ${mq(sizes.desktop)} {
    width: 100%;
    flex-direction: row;
  }
`
export const LegalItem = styled.li`
  & + & {
    margin: 1.25rem 0 0 0;
    @media ${mq(sizes.desktop)} {
      margin: 0 0 0 1.25rem;
    }
  }
`

export const LegalLink = styled(A)`
  ${({ theme }) => theme.textStyles.text_bold_14};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.pureWhite ?? 'white'};
`
